<template>
    <div class="page-content">
        <!--<el-button class="back" @click="onClickBack">返回</el-button>-->
        <div class="content">
            <div class="col-left">
                <!-- 舆情检测 -->
                <!-- <div class="col-left-item product-count-sort">
                    <div class="ratio">
                        <img src="https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png" alt class="img1" />
                        <div class="text1">舆情监测</div>
                    </div>
                    <div class="change-btn">
                        <span>换一换</span>
                    </div>
                    <div class="detection_wp1">
                        <div class="detection_wp">
                        <div class="detection" v-for="(item,index) in detection" :key="index">
                            <span
                            :class="index==0?'active1':index==1?'active2':index==2?'active3':''"
                            >{{index+1}}</span>
                            <span>{{item.text}}</span>
                            <span v-show="item.status==1?true:false">新</span>
                            <span v-show="item.status==2?true:false">热</span>
                            <span>{{item.num}}</span>
                        </div>
                        </div>
                    </div>
                </div> -->
                <!-- 游客画像 -->
                <div class="col-left-item product-count-sort">
                    <div class="ratio">
                        <img src="https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png" alt class="img1" />
                        <div class="text1">游客画像</div>
                    </div>
                    <div class="tourist_wp">
                        <div class="tourist">
                            <div class="grden_wp">
                                <div class="grden">
                                    <img src="https://smsycs.hxxpl.com.cn/2020/202007071321269246000.png" alt />
                                    <div>
                                        <p>男性游客</p>
                                        <p v-if="dataIndex==0">57%</p>
                                        <p v-if="dataIndex==1">55%</p>
                                        <p v-if="dataIndex==2">55%</p>
                                    </div>
                                </div>
                                <div class="grden">
                                    <img src="https://smsycs.hxxpl.com.cn/2020/202007071321338620954.png" alt />
                                    <div>
                                        <p>女性游客</p>
                                        <p v-if="dataIndex==0">43%</p>
                                        <p v-if="dataIndex==1">45%</p>
                                        <p v-if="dataIndex==2">45%</p>
                                    </div>
                                </div>
                            </div>
                            <div class="grden_bl">
                                <!--游客年龄比例图-->
                                <div class="sale-total-map" id="sale-total-map"></div>
                                <!-- 比例图说明 -->
                                <div class="tourist_select">
                                    <div class="tourist_select_lsit">
                                        <div class="tourist_select_lsit_itme" v-for="(item,index) in tourist" :key="index">
                                            <i :style="{'backgroundColor':item.itemStyle.color}"></i>
                                            <span>{{item.name}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ranking_origin">
                            <div class="ranking_origin_title">客源地排名</div>
                            <div id="ranking_origin_echart"></div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="lower-left-corner" style="display:block">
                        <!--游客消费数据分析-->
                        <div class="tourist-consumption-wp" style="display:block">
                            <div class="ratio">
                                <img src="https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png" alt class="img1" />
                                <div class="text1">游客消费数据分析</div>
                                <!-- <span class="noData">未接入数据</span> -->
                            </div>
                            <div class="tourist-consumption-content" style="margin-top:15px">
                                <div class="tourist-consumption">
                                    <div class="tourist-consumption-title">
                                        <div v-for="(item,index) in consumtitle" :key="index">
                                            <i :style="{'background-color':item.color}"></i>
                                            <span>{{item.name}}</span>
                                        </div>
                                    </div>
                                    <div id="tourist-consumption-img" style="margin-top:10px"></div>
                                </div>

                                <div id="tourist-consumption-echart"></div>
                            </div>
                            <!-- 游客行为分析 -->
                            <div class="tourist_behavior" style="margin-top:30px">
                                <!-- <div class="tourist_behavior_title">游客行为分析</div> -->
                                <div id="tourist_behavior_echart"></div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <div class="col-right">
                <div class="col-right-top">
                    <!-- 中上 -->
                    <div class="col-right-top-left">
                        <div class="col-title">
                            <img src="https://smsycs.hxxpl.com.cn//2020/202006190909187410673.png" class="img-line2" alt />
                            <!-- <img
                                class="col-title-text3"
                                src="https://smsycs.hxxpl.com.cn/2020/202007081000198621059.png"
                            /> -->
                            <!-- <div class="col-title-text">浙江省统一文旅分时预约及监测平台</div> -->
                            <div class="col-title-text">浙江省景区分时预约及监测</div>
                            <!-- <div
                                class="col-title-text2"
                                v-if="dataIndex==0"
                            >全国文旅统一预约预定及舆情监测系统</div>
                            <div
                                class="col-title-text2"
                                v-if="dataIndex==1"
                            >浙江文旅统一预约预定及舆情监测系统</div>
                            <div
                                class="col-title-text2"
                                v-if="dataIndex==2"
                            >杭州文旅统一预约预定及舆情监测系统</div> -->
                        </div>
                        <!-- 跑马灯 -->
                        <!-- <div class="order_lamp">
                            <swiper :options="swiperOptions">
                                <swiper-slide v-for="(item,index) in lamp" :key="index">
                                    <span style="color:#9FBFE0">{{index}}最新订单：</span>
                                    <span style="color:#B2F7FF">[1分钟前]</span>
                                    <span style="color:#E5B73E">安吉中南百草原门票|儿童票|1.2至1.5米</span>
                                    <span style="color:#9FBFE0">尾号1234预订2张</span>
                                </swiper-slide>
                                <div class="swiper-pagination" slot="pagination"></div>
                            </swiper>
                        </div> -->
                        <!-- 预约总量 -->
                        <div class="total_appointments">
                            <div>今日预约总量</div>
                            <div class="current_tourists_num_left">
                                <span v-for="(item,index) in totalAppointmentsMy" :key="index" v-html="item?item:0"></span>
                                <div>人</div>
                            </div>
                        </div>
                        <!--地图-->
                        <div class="map-content" id="chinaMap"></div>
                    </div>
                    <!-- 右上 -->
                    <div>
                        <!--spu数据-->
                        <div class="spu-data">
                            <!--分时预约人次-->
                            <div class="spu-data-list">
                                <div style="display:flex;align-items: center;cursor: pointer;" v-show="dataIndex==0" @click="appointment=0">
                                    <i style="width:26px;height:26px;margin-right:4px" v-show="appointment==1"></i>
                                    <img v-show="appointment==0" src="https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png" alt class="" style="width:26px;height:26px;margin-right:4px" />
                                    <div class="spu-data-list-title">各市分时预约排名</div>
                                </div>
                                <div style="display:flex;align-items: center;margin-right:20px;cursor: pointer;" @click="appointment=1">
                                    <img v-show="appointment==1" src="https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png" alt class="" style="width:26px;height:26px;margin-right:4px" />
                                    <div class="spu-data-list-title">景区分时预约排名</div>
                                </div>
                            </div>
                            <div class="spu-data-list-time" style="height:30px;line-height:30px;margin-top:16px;margin-right:10px">
                                <!-- <span @click="timeTap(0)" :class="0==sputimeIndex?'active6':''">当日</span>
                                <span @click="timeTap(1)" :class="1==sputimeIndex?'active6':''">未来3天</span>
                                <span @click="timeTap(2)" :class="2==sputimeIndex?'active6':''">未来一周</span> -->
                                <el-date-picker class="sup-time-choose" v-model="spuTime" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" style="float:right"></el-date-picker>
                            </div>
                            <div class="spu-data-list-nav">
                                <!-- <span v-if="dataIndex==0">省</span> -->
                                <span v-if="dataIndex==0&&appointment==0">市</span>
                                <span v-if="appointment==1||dataIndex==2">景区</span>
                                <span>当日<br />预约数量</span>
                                <!-- <span>预约<br />总人数</span> -->
                                <span>未来三天<br />预约数量</span>
                                <span>未来一周<br />预约数量</span>
                                <!-- <span>预约率</span> -->
                            </div>
                            <!--spu top列表-->
                            <!-- restart -->

                            <div class="spu_list_wp" ref="spuList">
                                <!-- <div :style="{'--heightSpu':heightSpu,}" :class="appointment==0&&dataIndex==0?'spu_list animation_m1':'spu_list'" id="spu_list" ref="spuAnimation"></div> -->
                                <div :style="{'--heightSpu':heightSpu}" :class="appointment==0&&dataIndex==0?'spu_list animation_m1':'spu_list'" ref="spuAnimation" id="spu_list" class="new-spu-list">
                                    <div v-for="(item,index) in spudataList" :key="index">
                                        <span class="name-new">
                                            <span :style="{'--backColor':index<3?colorList[index]:colorList[3]}">{{index+1}}</span>
                                            <span @click="scenicDetail(item.scenic_name)">{{item.scenic_name||item.city}}</span>
                                        </span>
                                        <span class="number-new" style="width:102px">{{item.orderNum}}</span>
                                        <span class="number-new" style="width:112px">{{item.threeOrder||item.threeOrderNum}}</span>
                                        <span class="number-new" style="width:115px">{{item.sevenOrder||item.sevenOrderNum}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- OTA -->
                        <div class="OTA_data">
                            <div class="ratio" style="margin-top:12px">
                                <img src="https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png" alt class="img1" />
                                <div class="text1">当天及未来7天OTA数据</div>
                            </div>
                            <div class="OTA_data_wp">
                                <div class="project_access_ratio">
                                    <span>渠道</span>
                                    <span class="ratio_tital">当日<br />预约数量</span>
                                    <span class="ratio_tital">未来七天<br />预约数量</span>
                                    <span>当日预约<br />数量占比</span>
                                </div>
                                <div class="OTA_data_echart_wp" :style="{'--heightOTA':heightOTA,'--OTAtop':OTAtop,'--OTAheight':OTAheight}">
                                    <div id="OTA_data_echart" class="OTA_data_echartsss"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--中下-->
                <div class="col-right-bottom">
                    <!--健康码使用率-->
                    <div class="sale-content">
                        <div class="ratio">
                            <img src="https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png" alt class="img1" />
                            <div class="text1">健康码使用率</div>
                            <!-- <span class="noData">未接入数据</span> -->
                        </div>
                        <!--健康码使用率列表-->
                        <!-- <div style="text-align:center;font-size:15px;color:#d7e6f5;margin-top:128px">未接入数据</div> -->
                        <div class="healthCode_wp">
                            <div class="healthCode_line1"></div>
                            <div class="healthCode_line2"></div>
                            <div class="healthCode" v-for="(item,index) in healthCode1" :key="index">
                                <span :class="index==0?'active1':index==1?'active2':index==2?'active3':''">{{index+1}}</span>
                                <span>{{item.text}}</span>
                                <span>{{item.num}}</span>
                            </div>
                        </div>
                        <!-- <div class="healthCode_wp">
                            <div class="healthCode_line1"></div>
                            <div class="healthCode_line2"></div>
                            <div class="healthCode" v-for="(item,index) in healthCodeList" :key="index">
                                <span :class="index==0?'active1':index==1?'active2':index==2?'active3':''">{{index+1}}</span>
                                <span>{{item.city}}</span>
                                <span>{{item.percentage}}</span>
                            </div>
                        </div> -->
                    </div>
                    <!-- 预约出行率 -->
                    <div class="travel_wp">
                        <div class="ratio sale-content-ratio">
                            <img src="https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png" alt class="img1" />
                            <div class="text1">预约出行率</div>
                        </div>
                        <div class="travel_select">
                            <span @click="timeTap1(0)" :class="0==sputimeIndex2?'active5':''">过去30日</span>
                            <span @click="timeTap1(1)" :class="1==sputimeIndex2?'active5':''">过去7日</span>
                        </div>
                        <!-- 出行比例说明 -->
                        <div class="tranvel_map_wp">
                            <div class="travel_map" id="travel_map"></div>
                            <div class="tranvel_label_wp">
                                <!-- <span v-for="(item,index) in travel" :key="index"><i :style="item.color"></i>{{item.text+item.pre}}</span> -->
                                <span v-for="(item,index) in travel" :key="index"><i :style="item.color"></i>{{item.text}}</span>
                            </div>
                            <!-- <div style="text-align:center;font-size:15px;color:#d7e6f5;margin-top:80px">未接入数据</div> -->
                        </div>
                    </div>
                    <!--项目接入比例-->
                    <div class="application-content">
                        <div class="ratio" style="margin-top:12px">
                            <img src="https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png" alt class="img1" />
                            <div class="text1">浙里好玩入驻率</div>
                        </div>

                        <div class="analysis_tourist_wp">
                            <div class="project_access_ratio">
                                <span style="width:17%">市</span>
                                <span class="ratio_tital">总景区数量</span>
                                <span class="ratio_tital">已入驻<br />景区数量</span>
                                <span>占比</span>
                            </div>
                            <div class="access_ratio_scroll">
                                <div id="access_ratio_echart" class="access_ratio_echartss"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog_wp" v-if="isDialog">
            <div class="detail_content">
                <img class="closeDetail" @click="closeDetail" src="https://smsycs.hxxpl.com.cn/2020/202007150957413440081.png" />
                <scenicDetails></scenicDetails>
            </div>
        </div>
    </div>
</template>
<style type="text/css" scoped>
@import 'systemDataDisplay.css';
</style>
<script>
import Vue from 'vue'
import echarts from 'echarts'
import pieOption from './systemDataDisplay'
let myData = require('echarts/map/json/province/henan.json')
let china = require('echarts/map/js/china') // 引入中国地图数据
let henan = require('echarts/map/json/province/henan.json') //
let shanghai = require('echarts/map/json/province/shanghai.json')
let hebei = require('echarts/map/json/province/hebei.json')
let shangxi = require('echarts/map/json/province/shanxi.json')
let neimenggu = require('echarts/map/json/province/neimenggu.json')
let liaoning = require('echarts/map/json/province/liaoning.json')
let jilin = require('echarts/map/json/province/jilin.json')
let heilongjiang = require('echarts/map/json/province/heilongjiang.json')
let jiangsu = require('echarts/map/json/province/jiangsu.json')
let zhejiang = require('echarts/map/json/province/zhejiang.json')
let anhui = require('echarts/map/json/province/anhui.json')
let fujian = require('echarts/map/json/province/fujian.json')
let jiangxi = require('echarts/map/json/province/jiangxi.json')
let shangdong = require('echarts/map/json/province/shandong.json')
import Highcharts from 'highcharts/highstock'
import HighchartsMore from 'highcharts/highcharts-more'
import HighchartsDrilldown from 'highcharts/modules/drilldown'
import Highcharts3D from 'highcharts/highcharts-3d'
HighchartsMore(Highcharts)
HighchartsDrilldown(Highcharts)
Highcharts3D(Highcharts)
// 详情页
import scenicDetails from '../../assets/scenicDetails/scenicDetail'
export default {
    name: 'systemDataDisplay',
    data() {
        return {
            dayDate: new Date(),
            dataIndex: 0,
            echartRatio: '', //比例图
            appointment: 0,
            pieIndex: 0,
            isDialog: false,
            // 检测
            detection: [
                {
                    text: '【浙江杭州】西溪湿地景区部分景区厕所暂停使用',
                    num: '4000',
                    status: 0
                },
                {
                    text: '【四川阿坝藏族羌族自治州】九寨沟景区垃圾桶少',
                    num: '6000',
                    status: 1
                },
                {
                    text: '【安徽黄山】黄山风景区旅游快速通道被洪水冲断',
                    num: '6500',
                    status: 2
                },
                {
                    text: '【广西南宁】青秀山景区不接受现金购票遭质疑',
                    num: '5800',
                    status: 0
                },
                {
                    text: '【江西九江】庐山景区酒店泄露隐私，卫生堪忧',
                    num: '5600',
                    status: 0
                },
                {
                    text: '【黑龙江牡丹江海林市】雪乡景区遭遇了“价格欺诈”',
                    num: '5500',
                    status: 0
                },
                {
                    text: '【甘肃省张掖市】张掖丹霞地质公园被踩踏',
                    num: '5000',
                    status: 0
                },
                {
                    text: '【青海省海西蒙古族藏族自治州】茶卡盐湖变垃圾场',
                    num: '4800',
                    status: 0
                },
                {
                    text: '【湖南张家界】张家界景区管理混乱，票价不一',
                    num: '4000',
                    status: 0
                },
                {
                    text: '【云南丽江】游客被坑屡见不鲜',
                    num: '3200',
                    status: 0
                }
            ],
            // 健康码0
            healthCode: [
                {
                    text: '浙江省',
                    num: '57%'
                },
                {
                    text: '江西省',
                    num: '19%'
                },
                {
                    text: '海南省',
                    num: '3%'
                },
                {
                    text: '河北省',
                    num: '0'
                },
                {
                    text: '江苏省',
                    num: '0'
                },

                {
                    text: '湖南省',
                    num: '0'
                },

                {
                    text: '湖北省',
                    num: '0'
                },
                {
                    text: '四川省',
                    num: '0'
                },
                {
                    text: '云南省',
                    num: '0'
                },
                {
                    text: '贵州省',
                    num: '0'
                },
                {
                    text: '山西省',
                    num: '0'
                },
                {
                    text: '广西省',
                    num: '0'
                },
                {
                    text: '广东省',
                    num: '0'
                },
                {
                    text: '福建省',
                    num: '0'
                },
                {
                    text: '山东省',
                    num: '0'
                }
            ],
            // 健康码1
            healthCode1: [
                {
                    text: '杭州市',
                    num: '78%'
                },
                {
                    text: '湖州市',
                    num: '75%'
                },
                {
                    text: '嘉兴市',
                    num: '68%'
                },
                {
                    text: '绍兴市',
                    num: '59%'
                },
                {
                    text: '宁波市',
                    num: '55%'
                },

                {
                    text: '舟山市',
                    num: '53%'
                },

                {
                    text: '金华市',
                    num: '49%'
                },
                {
                    text: '丽水市',
                    num: '47%'
                },
                {
                    text: '台州市',
                    num: '45%'
                },
                {
                    text: '温州市',
                    num: '42%'
                },
                {
                    text: '衢州市',
                    num: '40%'
                }
            ],
            // 健康码1
            healthCode2: [
                {
                    text: '西湖区',
                    num: '57%'
                },
                {
                    text: '上城区',
                    num: '19%'
                },
                {
                    text: '下城区',
                    num: '3%'
                },
                {
                    text: '江干区',
                    num: '0'
                },
                {
                    text: '拱墅区',
                    num: '0'
                },
                {
                    text: '滨江区',
                    num: '0'
                },
                {
                    text: '富阳区',
                    num: '0'
                },
                {
                    text: '萧山区',
                    num: '0'
                },
                {
                    text: '余杭区',
                    num: '0'
                }
            ],
            navData: [
                {
                    name: '商户活跃度(2C订单)',
                    icon: 'https://smsycs.hxxpl.com.cn//2020/202006171020345379463.png',
                    selectIcon:
                        'https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png',
                    value: 20,
                    total: 100
                },
                {
                    name: '商户活跃度(2B订单)',
                    icon: 'https://smsycs.hxxpl.com.cn//2020/202006171020345379463.png',
                    selectIcon:
                        'https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png',
                    value: 80,
                    total: 100
                }
            ],
            selectIndex: null, //订单柱状图选中的index
            orderSelectData: ['今日', '本周'],
            selectData: ['今日', '本周', '本月', '全年'],
            value1: '',
            spuSelectIndex: 0, //spu选中的index
            sputimeIndex: 1, //sputime选中的index
            sputimeIndex2: 0,
            spuTapData: [
                {
                    title: '分时预约人次',
                    icon: 'https://smsycs.hxxpl.com.cn//2020/202006171020345379463.png',
                    selectIcon:
                        'https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png'
                },
                {
                    title: '客源地排名',
                    icon: 'https://smsycs.hxxpl.com.cn//2020/202006171020345379463.png',
                    selectIcon:
                        'https://smsycs.hxxpl.com.cn//2020/202006161654594910813.png'
                }
            ],
            totalAppointments: [],
            totalAppointmentsMy: [0, 0, 0, 0],
            spuTime: [],
            rankList: [
                '千岛湖九龙溪漂流（成人票）',
                '慈城古县城成人票',
                '宁海森林温泉度假村',
                '海宁开元美途酒店',
                '杭州千岛湖峰泰君亭酒店',
                '温州极地海洋世界（成人票）',
                '天源豪生酒店',
                '天源豪生酒店1'
            ],
            province: 0,
            provinceList: [
                {
                    label: '浙江省',
                    value: 0
                }
            ],
            tourist: [],
            make: [
                {
                    province: '浙江省',
                    num: '17956',
                    pre: 100
                },
                {
                    province: '江西省',
                    num: '3952',
                    pre: 65
                },
                {
                    province: '河南省',
                    num: '759',
                    pre: 56
                },
                {
                    province: '江苏省',
                    num: '0',
                    pre: 0
                },
                {
                    province: '湖北省',
                    num: '0',
                    pre: 0
                },
                {
                    province: '湖南省',
                    num: '0',
                    pre: 0
                },

                {
                    province: '河北省',
                    num: '0',
                    pre: 0
                },
                {
                    province: '四川省',
                    num: '0',
                    pre: 0
                },
                {
                    province: '云南省',
                    num: '0',
                    pre: 0
                },
                {
                    province: '贵州省',
                    num: '0',
                    pre: 0
                }
            ],
            travel: [
                {
                    color: { backgroundColor: '#6E65EF' },
                    text: '预约出行率',
                    pre: '12%'
                },
                {
                    color: { backgroundColor: '#FFB833' },
                    text: '预约爽约',
                    pre: '10%'
                },
                {
                    color: { backgroundColor: '#6EB2ED' },
                    text: '预约中',
                    pre: '15%'
                }
            ],
            region: [
                {
                    name: '浙江省',
                    num: 792,
                    pre: '47%'
                },
                {
                    name: '江西省',
                    num: 638,
                    pre: '17%'
                },
                {
                    name: '海南省',
                    num: 569,
                    pre: '7%'
                },
                {
                    name: '湖北省',
                    num: 0,
                    pre: '0'
                },
                {
                    name: '河南省',
                    num: 0,
                    pre: '0'
                }
            ],
            region1: [
                {
                    name: '杭州市',
                    num: 792,
                    pre: '47%'
                },
                {
                    name: '湖州市',
                    num: 638,
                    pre: '17%'
                },
                {
                    name: '嘉兴市',
                    num: 569,
                    pre: '7%'
                },
                {
                    name: '绍兴市',
                    num: 0,
                    pre: '0'
                },
                {
                    name: '宁波市',
                    num: 0,
                    pre: '0'
                }
            ],
            region2: [
                {
                    name: '西湖区',
                    num: 792,
                    pre: '47%'
                },
                {
                    name: '上城区',
                    num: 638,
                    pre: '17%'
                },
                {
                    name: '下城区',
                    num: 569,
                    pre: '7%'
                },
                {
                    name: '江干区',
                    num: 0,
                    pre: '0'
                },
                {
                    name: '拱墅区',
                    num: 0,
                    pre: '0'
                }
            ],
            analysis: [
                {
                    name: '杭州西湖',
                    num: '25000'
                },
                {
                    name: '乌镇',
                    num: '14500'
                },
                {
                    name: '灵隐寺',
                    num: '9800'
                },
                {
                    name: '西溪湿地',
                    num: '8950'
                },
                {
                    name: '普陀山风景区',
                    num: '7700'
                },
                {
                    name: '雁荡山',
                    num: '7000'
                }
            ],
            analysis1: [
                {
                    name: '石花洞',
                    num: '25000'
                },
                {
                    name: '盘山',
                    num: '14500'
                },
                {
                    name: '承德避暑山庄',
                    num: '9800'
                },
                {
                    name: '扎兰屯',
                    num: '8950'
                },
                {
                    name: '青山沟',
                    num: '7700'
                },
                {
                    name: '太阳岛',
                    num: '7000'
                }
            ],
            analysis2: [
                {
                    name: '良渚古城遗址',
                    num: '25000'
                },
                {
                    name: '杭州西湖',
                    num: '14500'
                },
                {
                    name: '千岛湖',
                    num: '9800'
                },
                {
                    name: '西溪湿地',
                    num: '8950'
                },
                {
                    name: '乌镇',
                    num: '8950'
                },
                {
                    name: '灵隐寺',
                    num: '8950'
                }
            ],
            access: [
                {
                    name: '浙江省',
                    num: '1000',
                    total: '1200'
                },
                {
                    name: '江西省',
                    num: '800',
                    total: '1000'
                },
                {
                    name: '海南省',
                    num: '700',
                    total: '900'
                },
                {
                    name: '江苏省',
                    num: '600',
                    total: '800'
                },
                {
                    name: '湖北省',
                    num: '550',
                    total: '750'
                },
                {
                    name: '湖南省',
                    num: '490',
                    total: '690'
                }
            ],
            access1: [
                {
                    name: '杭州市',
                    num: '1000',
                    total: '1200'
                },
                {
                    name: '湖州市',
                    num: '800',
                    total: '1000'
                },
                {
                    name: '嘉兴市',
                    num: '700',
                    total: '900'
                },
                {
                    name: '绍兴市',
                    num: '600',
                    total: '800'
                },
                {
                    name: '宁波市',
                    num: '550',
                    total: '750'
                },
                {
                    name: '舟山市',
                    num: '470',
                    total: '670'
                },
                {
                    name: '金华市',
                    num: '430',
                    total: '630'
                },
                {
                    name: '丽水市',
                    num: '350',
                    total: '550'
                },
                {
                    name: '台州市',
                    num: '350',
                    total: '550'
                },
                {
                    name: '温州市',
                    num: '320',
                    total: '520'
                },
                {
                    name: '衢州市',
                    num: '300',
                    total: '500'
                }
            ],
            access2: [
                {
                    name: '西湖区',
                    num: '1000',
                    total: '1200'
                },
                {
                    name: '上城区',
                    num: '800',
                    total: '1000'
                },
                {
                    name: '下城区',
                    num: '700',
                    total: '900'
                },
                {
                    name: '江干区',
                    num: '600',
                    total: '800'
                },
                {
                    name: '拱墅区',
                    num: '550',
                    total: '750'
                },
                {
                    name: '滨江区',
                    num: '490',
                    total: '690'
                },
                {
                    name: '富阳区',
                    num: '470',
                    total: '670'
                },
                {
                    name: '萧山区',
                    num: '430',
                    total: '630'
                },
                {
                    name: '余杭区',
                    num: '400',
                    total: '600'
                }
            ],
            saleIndex: 0,
            valueSale: '',
            saleTapData: ['景区TOP5', '酒店', '民宿', '博物馆'],
            saleTapIndex: 0,
            ratioMap: '', //饼图
            orderMap: '', //订单人数柱状图
            productMap: '', //产品处饼图
            saleTotalMap: '', //销售总额柱状图
            TravelMaps: '', //预约出行比例
            chinaMap: '',//中国地图
            /* 游客消费头部 */
            consumtitle: [
                { name: '景区消费', y: 0, color: '#4E7DF4' },
                { name: '住宿消费', y: 0, color: '#EDA669' },
                { name: '餐饮消费', y: 0, color: '#87B5E7' },
                { name: '购物消费', y: 0, color: '#8088E2' },
                { name: '娱乐消费', y: 0, color: '#A5E98A' },
                { name: '交通消费', y: 0, color: '#F75E6C' }
            ],
            /* 请求数据开始 */
            spudataList: [],//景区
            colorList: ['#DA5D7E', '#F18B55', '#F5AE50', '#4486C5', '#5AACEA'],
            healthCodeList: [],//健康码
            projectAccessList: [],//项目接入比例
            heightSpu: '-300px',
            heightOTA: '-120px',
            OTAheight: '-130px',
            OTAtop: '0px',
            animation: 0,
            supName: '',
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination'
                },
                direction: 'vertical',
                observer: true,//修改swiper自己或子元素时，自动初始化swiper
                observeParents: true,//修改swiper的父元素时，自动初始化swiper
                loop: true,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                },
                speed: 1000,

            },
            lamp: [1, 2, 3],
            timer: null
        }
    },
    watch: {
        dataIndex(val) {
            // if (val == 0) {
            //     this.totalAppointments = [4, 2, 3]
            //     this.supData(0, [this.getDate(new Date()), this.getDate(new Date())])
            // } else {
            //     this.totalAppointments = [1, 2, 5]
            // }
            // this.totalAppointmentsMy = [0, 0, 0,0]
            // this.numberChange(this.totalAppointments)
        },
        appointment(val) {
            this.sputimeIndex = 0
            this.$refs.spuList.scrollTop = 0
            if (val == 1) {
                this.supData(1, [this.getDate(new Date()), this.getDate(new Date())])
            } else {
                this.supData(0, [this.getDate(new Date()), this.getDate(new Date())])
            }
        },
        spuTime(val) {
            return
            if (val) {
                this.supData(this.appointment, [val[0], val[1]])
            } else {
                this.supData(this.appointment, [this.getDate(new Date()), this.getDate(new Date())])
            }

        },
        sputimeIndex(val) {
            if (this.appointment == 0) {
                var arr = [...this.$refs.spuAnimation.classList]
                if (arr.indexOf('animation_m1') >= 0) {
                    this.$refs.spuAnimation.classList.remove('animation_m1')
                    this.$refs.spuAnimation.classList.add('animation_m2')

                } else {
                    this.$refs.spuAnimation.classList.remove('animation_m2')
                    this.$refs.spuAnimation.classList.add('animation_m1')
                }
            }
        }
    },
    mounted() {
        // 总量
        this.totalappointments(this.supName)
        // spu数据
        var date = new Date().getTime() + 3 * 24 * 3600 * 1000
        // this.supData(this.appointment, [this.getDate(new Date()), this.getDate(new Date(date))])
        this.supData(0)
        // 健康码
        // this.healthCodeData()
        // 浙里好玩入住率
        this.getProjectAccess()
        // OTA
        this.OTAData1()
        // 客源地排名
        this.rankingOriginData()
        // 游客消费排名
        this.touristConsumption()
        // 游客消费饼图
        this.getPeopleConsume()
        // 游客行为分析
        this.consumerBehavior()
        // //加载饼图
        // this.getRatioMap();
        //sup柱状图
        // this.setOrderMap()
        // //产品数量及分类图
        // this.getProductMap();
        //游客画像
        this.ageConsumption()

        // 客源地排名
        // this.rankingOrigin()
        //地图
        this.initMap()
        // this.getMap()
        //预约出行比例
        this.TravelMap()
        // 游客停留时长
        // this.stayEchart()
        // 游客分布分析
        // this.analysisEchart()
    },
    methods: {
        totalappointments() {
            this.$http
                .get('/apimt/zhejiangOrder/getAppointmentNum', {
                    params: {
                        city: this.supName
                    }
                })
                .then((res) => {
                    this.totalAppointments = `${res.data.orderNum}`.split('')
                    this.totalAppointmentsMy = []
                    for (let index = 0; index < this.totalAppointments.length; index++) {
                        this.totalAppointmentsMy.push(0)
                    }
                    this.numberChange(this.totalAppointments)
                }).catch(() => {
                })
        },
        supData(num) {
            if (num == 0) {
                /* sup市 */
                this.$http
                    .get('/apimt/zhejiangOrder/getCityOrderDataNewNew',)
                    .then((res) => {
                        var data = res.data;
                        console.log(data);
                        this.spudataList = data
                        // this.setOrderMap(data)
                    }).catch(() => {
                    })
            } else {
                /* sup景区 */
                this.$http
                    .get('/apimt/zhejiangOrder/getOrderDataNewNew', {
                        params: {
                            city: this.supName
                        }
                    })
                    .then((res) => {
                        var data = res.data;
                        console.log(data);
                        this.spudataList = data
                        // var arr = []
                        // data.map(item => {
                        //     if (arr.length < 110) {
                        //         arr.push(item)
                        //     }
                        // })
                        // this.setOrderMap(arr)

                    }).catch(() => {
                    })
            }
        },
        healthCodeData() {
            this.$http
                .get('/apimt/zhejiangOrder/getHealthCodePercentage')
                .then((res) => {
                    this.healthCodeList = res.data
                }).catch(() => {
                })
        },
        /* 项目接入比例 */
        getProjectAccess() {
            this.$http
                .get('/apimt/zhejiangOrder/getProjectAccess')
                .then((res) => {
                    var data = res.data;
                    var city = []
                    var totalNum = []
                    var orderNum = []
                    var percentage = []
                    data.map(item => {
                        city.push(item.city)
                        totalNum.push(item.totalNum)
                        orderNum.push(item.alreadyNum)
                        percentage.push(item.percentage ? item.percentage * 1 : 0)
                    })
                    this.accessrEchart(city, orderNum, totalNum, percentage)
                }).catch(() => {
                })
        },
        OTAData1() {
            this.$http
                .get('/apimt/zhejiangOrder/getOTA')
                .then((res) => {
                    var data = res.data;
                    var city = []
                    var totalNum = []
                    var orderNum = []
                    var percentage = []
                    data.map(item => {

                        if (item.totalNum > 0) {
                            city.push(item.source)
                            totalNum.push(item.totalNum)
                            orderNum.push(item.orderNum)
                            percentage.push(item.rate)
                        }
                        // if (item.source == '浙里好玩' || item.source == '携程' || item.source == '美团' || item.source == '去哪儿') {
                        //     city.push(item.source)
                        //     totalNum.push(item.totalNum)
                        //     orderNum.push(item.orderNum)
                        //     percentage.push(item.rate)
                        // }
                    })

                    if (city.length > 4) {
                        this.heightOTA = -30 * city.length + 'px'
                        this.OTAtop = '40px'
                        this.OTAheight = '75px'
                    } else {
                        this.heightOTA = '0px'
                        this.OTAtop = '0px'
                        this.OTAheight = '130px'
                    }
                    this.OTAData(city, orderNum, totalNum, percentage)
                }).catch(() => {
                })
        },
        rankingOriginData() {
            this.$http
                .get('/apimt/zhejiangOrder/getCustomers')
                .then((res) => {
                    var data = res.data;
                    var city = []
                    var percentage = []
                    data.map(item => {
                        city.push(item.Key)
                        percentage.push(item.Num)
                    })

                    this.rankingOrigin(city, percentage)
                }).catch(() => {
                })
        },
        /* 消费饼图 */
        getPeopleConsume() {
            this.$http
                .get('/apimt/zhejiangOrder/getPeopleConsume')
                .then((res) => {
                    var data = res.data;
                    var percentage = []
                    data.map(item => {
                        percentage.push({
                            name: item.name,
                            y: item.consume * 1,
                            color: item.name == '住宿消费' ? '#EDA669' : item.name == '景区消费' ? '#4E7DF4' : item.name == '餐饮消费' ? '#87B5E7' : item.name == '购物消费' ? '#8088E2' : item.name == '娱乐消费' ? '#A5E98A' : '#F75E6C'
                        })
                    })
                    this.initChart(percentage)
                }).catch(() => {
                })
        },
        getDate(date) {
            var year = date.getFullYear()
            var month = date.getMonth()
            var days = date.getDate()
            var date =
                year +
                '-' +
                (month + 1 < 10 ? '0' + (month + 1) : month + 1) +
                '-' +
                (days < 10 ? '0' + days : days)

            return date
        },
        numberChange(arrNum) {
            var max = Math.max(...arrNum)
            var s = max > 5 ? 200 : 300
            clearTimeout(this.timer)
            this.timer = setInterval(() => {
                this.totalAppointmentsMy = arrNum.map((item, index) => {
                    var num = this.totalAppointmentsMy[index] ? this.totalAppointmentsMy[index] : 0;
                    if (num >= max) {
                        clearTimeout(this.timer)
                        return num
                    } else {
                        if (num >= item) {
                            return this.totalAppointmentsMy[index]
                        } else {
                            num++
                            return num
                        }
                    }
                })
                this.totalAppointments = this.totalAppointmentsMy
            }, s);
        },
        /* 年龄消费 */
        ageConsumption() {
            let color = ['#67CFA9', '#F55A53', '#6E65EF', '#FFB833', '#6EB2ED', '#F5F4C6']
            this.$http
                .get('/apimt/stage/getAgeStage')
                .then((res) => {
                    var data = res.data.sort((a, b) => {
                        var A = parseInt(a.ageStage);
                        var B = parseInt(b.ageStage);

                        return A - B
                    })
                    var list = []
                    data.filter((item, index) => {
                        list.push({
                            value: item.percentage * 1,
                            name: item.ageStage,
                            itemStyle: {
                                color: color[index]
                            }
                        })
                    })
                    this.tourist = list
                    this.getRankMap(list)
                }).catch(() => {
                })

        },
        /* 消费行为分析 */
        consumerBehavior() {
            this.$http
                .get('/apimt/stage/getConsumeStage')
                .then((res) => {
                    var data = res.data
                    var arrKey = []
                    var arrValue = []
                    data.filter(item => {
                        arrKey.push(item.consumeStage)
                        arrValue.push(item.percentage)
                    })
                    this.touristBehavior(arrKey, arrValue)
                }).catch(() => {
                })
        },
        //返回
        onClickBack() {
            this.$router.go(-1)
        },
        //饼图导航
        onClickPie(index) {
            this.pieIndex = index
            let option = pieOption.pieOption(this.navData[index])
            this.ratioMap.setOption(option)
        },
        //加载饼图
        getRatioMap() {
            this.ratioMap = echarts.init(document.getElementById('ratio-map'))
            let option = pieOption.pieOption(this.navData[this.pieIndex])
            this.ratioMap.setOption(option)
        },
        //sup柱状图
        setOrderMap(spudataList) {
            var index = 0
            // if (this.dataIndex == 0) {
            //     var dataList = [
            //         '浙江省',
            //         '江西省',
            //         '海南省',
            //         '江苏省',
            //         '湖北省',
            //         '湖南省',
            //         '河南省',
            //         '河北省',
            //         '四川省',
            //         '云南省',
            //         '贵州省',
            //         '山西省'
            //     ]
            //     var yData = [9000, 7300, 4200, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            //     var dataList2 = [17956, 10952, 7759, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            //     var dataList3 = [70, 60, 50, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            // } else

            var city = []
            var orderNum = []
            var totalNum = []
            var percentage = []

            if (this.appointment == 0 && this.dataIndex == 0) {
                spudataList.map(item => {
                    city.push(item.city)
                    orderNum.push(item.orderNum)
                    totalNum.push(item.threeOrder)
                    percentage.push(item.sevenOrder)
                })
            } else {
                spudataList.map(item => {
                    city.push(item.scenic_name)
                    orderNum.push(item.orderNum)
                    totalNum.push(item.threeOrderNum)
                    percentage.push(item.sevenOrderNum)
                })
            }
            var dataList = city
            var yData = orderNum
            var dataList2 = totalNum
            var dataList3 = percentage
            let colorList = ['#DA5D7E', '#F18B55', '#F5AE50', '#4486C5', '#5AACEA']
            let options = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        shadowStyle: {
                            shadowBlur: 20,
                            opacity: 0.6
                        }
                    }
                },
                legend: {
                    show: false
                },
                grid: {
                    left: 40,
                    top: 0,
                    height: 40 * city.length,
                    right: 0
                },
                barMaxWidth: '22',
                xAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    }
                },
                yAxis: [
                    {
                        type: 'category',
                        inverse: true,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisPointer: {
                            label: {
                                show: true,
                                margin: 30
                            }
                        },
                        data: dataList,
                        axisLabel: {
                            margin: 40,
                            fontSize: 16,
                            align: 'left',
                            color: '#5AACEA',
                            lineHeight: 18,
                            rich: {
                                a1: {
                                    color: '#fff',
                                    backgroundColor: colorList[0],
                                    width: 18,
                                    height: 18,
                                    align: 'center'
                                },
                                a2: {
                                    color: '#fff',
                                    backgroundColor: colorList[1],
                                    width: 18,
                                    height: 18,
                                    align: 'center'
                                },
                                a3: {
                                    color: '#fff',
                                    backgroundColor: colorList[2],
                                    width: 18,
                                    height: 18,
                                    align: 'center'
                                },
                                b: {
                                    color: '#fff',
                                    backgroundColor: colorList[3],
                                    width: 18,
                                    height: 18,
                                    align: 'center'
                                },
                                name: {
                                    color: '#4DB0F4',
                                    width: 82,
                                    align: 'left',
                                    fontSize: 16
                                },
                                value1: {
                                    color: '#4DB0F4',
                                    width: 100,
                                    align: 'center',
                                    fontSize: 16
                                },
                                value2: {
                                    color: '#4DB0F4',
                                    width: 120,
                                    align: 'center',
                                    fontSize: 16
                                },
                                value3: {
                                    color: '#4DB0F4',
                                    width: 110,
                                    align: 'center',
                                    fontSize: 16
                                }
                            },
                            formatter: function (params) {
                                if (index == dataList2.length) {
                                    index = 0
                                }
                                index++
                                if (index - 1 < 3) {
                                    return [
                                        '{a' +
                                        index +
                                        '|' +
                                        index +
                                        '}' +
                                        '  ' +
                                        '{name|' +
                                        (params.length > 4
                                            ? params.substring(0, 4) + '...'
                                            : params) +
                                        '}{value1|' +
                                        yData[index - 1] +
                                        '}'
                                        +
                                        '{value2|' +
                                        dataList2[index - 1] +
                                        '}'
                                        +
                                        '{value3|' +
                                        dataList3[index - 1] +
                                        '}'
                                    ].join('\n')
                                } else {
                                    return [
                                        '{b|' +
                                        index +
                                        '}' +
                                        '  ' +
                                        '{name|' +
                                        (params.length > 4
                                            ? params.substring(0, 4) + '...'
                                            : params) +
                                        '}{value1|' +
                                        yData[index - 1] +
                                        '}'
                                        +
                                        '{value2|' +
                                        dataList2[index - 1] +
                                        '}'
                                        +
                                        '{value3|' +
                                        dataList3[index - 1] +
                                        '}'
                                    ].join('\n')
                                }
                            }
                        }
                    }
                ],
                series: [
                    // {
                    //     z: 2,
                    //     name: '人数',
                    //     type: 'bar',
                    //     barMinWidth: '20',
                    //     barMinHeight: '1',
                    //     barCategoryGap: '100',
                    //     data: dataList3.map((item, i) => {
                    //         let itemStyle = {
                    //             color: i > 3 ? colorList[3] : colorList[i]
                    //         }
                    //         return {
                    //             value: item,
                    //             itemStyle: itemStyle
                    //         }
                    //     }),
                    //     label: {
                    //         show: true,
                    //         position: 'right',
                    //         color: '#5AACEA',
                    //         fontSize: 16,
                    //         offset: [10, 0],
                    //         formatter: '{c}%'
                    //     }
                    // }
                ]
            }
            let myChart = echarts.init(document.getElementById('spu_list'))
            var that = this
            myChart.setOption(options)
            myChart.resize({ height: 60 * city.length })
            // myChart.getZr().off('click')
            myChart.on('click', function (params) {
                console.log(params);
                if (params.name == '良渚古城遗址公园') {
                    that.isDialog = true
                }
            })
        },
        // 游客区域逗留时长
        stayEchart() {
            if (this.dataIndex == 0) {
                var dataList = [
                    '浙江省',
                    '江西省',
                    '海南省',
                    '江苏省',
                    '湖北省',
                    '湖南省',
                    '河北省'
                ]
                var dataList2 = [42, 37, 33, 28, 27, 22, 19]
            } else if (this.dataIndex == 1) {
                var dataList = [
                    '杭州市',
                    '湖州市',
                    '嘉兴市',
                    '绍兴市',
                    '宁波市',
                    '舟山市',
                    '金华市'
                ]
                var dataList2 = [38, 35, 30, 28, 26, 22, 17]
            } else {
                var dataList = [
                    '西湖区',
                    '上城区',
                    '下城区',
                    '江干区',
                    '拱墅区',
                    '滨江区',
                    '富阳区'
                ]
                var dataList2 = [35, 34, 31, 29, 26, 22, 16]
            }
            let option = {
                grid: {
                    left: '5%',
                    top: '7%',
                    height: 200,
                    width: 420
                },
                xAxis: {
                    data: dataList,
                    splitNumber: 7,
                    minInterval: 1,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#4DB0F4',
                            width: 1 //这里是为了突出显示加上的
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#4DB0F4',
                            fontSize: 14
                        }
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        interval: 8,
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#4DB0F4',
                                width: 1 //这里是为了突出显示加上的
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#4DB0F4'
                            }
                        },
                        splitArea: {
                            areaStyle: {
                                color: 'rgba(255,255,255,.5)'
                            }
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#4DB0F4',
                                width: 0.5,
                                type: 'solid'
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: 'hill',
                        type: 'pictorialBar',
                        barCategoryGap: '0%',
                        symbol:
                            'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
                        label: {
                            show: true,
                            position: 'top',
                            distance: 15,
                            color: '#62B9A1',
                            fontWeight: 'bolder',
                            fontSize: 14
                        },
                        itemStyle: {
                            normal: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#62B9A1' //  0%  处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#62B9A1' //  100%  处的颜色
                                        }
                                    ],
                                    global: false //  缺省为  false
                                }
                            },
                            emphasis: {
                                opacity: 1
                            }
                        },
                        data: dataList2,
                        z: 10
                    }
                ]
            }
            echarts
                .init(document.getElementById('stay_time_echart'))
                .setOption(option)
        },
        // 游客分布分析
        analysisEchart() {
            if (this.dataIndex == 0) {
                var salvProName = [
                    '石花洞',
                    '盘山',
                    '承德避暑山庄',
                    '扎兰屯',
                    '青山沟',
                    '太阳岛'
                ]
            } else if (this.dataIndex == 1) {
                var salvProName = [
                    '杭州西湖',
                    '乌镇',
                    '灵隐寺',
                    '西溪湿地',
                    '普陀山风景区',
                    '雁荡山'
                ]
            } else {
                var salvProName = [
                    '良渚古城遗址',
                    '杭州西湖',
                    '千岛湖',
                    '西溪湿地',
                    '乌镇',
                    '灵隐寺'
                ]
            }
            var salvProValue = [70, 60, 40, 36, 30, 27]
            var salvProMax = [] //背景按最大值
            for (let i = 0; i < salvProValue.length; i++) {
                salvProMax.push(100)
            }
            let option = {
                grid: {
                    left: '-80',
                    right: '15%',
                    bottom: '2%',
                    top: '0',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none'
                    },
                    formatter: function (params) {
                        return params[0].name + ' : ' + params[0].value + '%'
                    }
                },
                barMaxWidth: 14,
                xAxis: {
                    show: false,
                    type: 'value'
                },
                yAxis: [
                    {
                        type: 'category',
                        inverse: true,
                        show: false,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#fff'
                            }
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        data: salvProName
                    },
                    {
                        type: 'category',
                        inverse: true,
                        axisTick: 'none',
                        axisLine: 'none',
                        show: true,
                        axisLabel: {
                            textStyle: {
                                color: '#4DB0F4',
                                fontSize: '12'
                            }
                        },
                        data: salvProValue.map(item => {
                            return item + '%'
                        })
                    }
                ],
                series: [
                    {
                        name: '值',
                        type: 'bar',
                        zlevel: 1,
                        itemStyle: {
                            normal: {
                                barBorderRadius: 30,
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                    {
                                        offset: 0,
                                        color: '#5472F2'
                                    },
                                    {
                                        offset: 1,
                                        color: '#5CBBE8'
                                    }
                                ])
                            }
                        },
                        barWidth: 14,
                        data: salvProValue
                    },
                    {
                        name: '背景',
                        type: 'bar',
                        barWidth: 14,
                        barGap: '-100%',
                        data: salvProMax,
                        itemStyle: {
                            normal: {
                                color: '#404D84',
                                barBorderRadius: 30
                            }
                        }
                    }
                ]
            }

            echarts
                .init(document.getElementById('analysis_tourist_echart'))
                .setOption(option)
        },
        // 浙里好玩入住比例
        accessrEchart(city, orderNum, totalNum, percentage) {
            let index = 0
            // if (this.dataIndex == 0) {
            //     var salvProName = [
            //         '浙江省',
            //         '江西省',
            //         '海南省',
            //         '江苏省',
            //         '湖北省',
            //         '湖南省'
            //     ]
            //     var salvProValue = [890, 880, 720, 360, 300, 270]
            //     var salvProValue1 = [90, 88, 72, 36, 30, 27]
            //     var salvProValue2 = [850, 800, 620, 260, 200, 200]
            // } else
            // if (this.dataIndex == 0) {
            //     var salvProName = [
            //         '杭州市',
            //         '湖州市',
            //         '嘉兴市',
            //         '绍兴市',
            //         '宁波市',
            //         '舟山市'
            //     ]
            //     var salvProValue = [860, 810, 700, 360, 300, 270]
            //     var salvProValue1 = [86, 81, 70, 36, 30, 27]
            //     var salvProValue2 = [810, 710, 600, 260, 200, 200]
            // } else {
            //     var salvProName = [
            //         '西湖区',
            //         '上城区',
            //         '下城区',
            //         '江干区',
            //         '拱墅区',
            //         '滨江区'
            //     ]
            //     var salvProValue = [790, 720, 680, 360, 300, 270]
            //     var salvProValue1 = [79, 72, 68, 36, 30, 27]
            //     var salvProValue2 = [700, 620, 600, 260, 200, 200]
            // }
            var salvProName = city
            var salvProValue = totalNum
            var salvProValue2 = orderNum
            var salvProValue1 = percentage
            var salvProMax = [] //背景按最大值
            for (let i = 0; i < salvProValue.length; i++) {
                salvProMax.push(100)
            }
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none'
                    },
                    formatter: function (params) {
                        return params[1].name + ' : ' + params[1].value + '%'
                    }
                },
                legend: {
                    show: false
                },
                grid: {
                    height: 30 * salvProName.length,
                    left: -60,
                    right: '5%',
                    bottom: '2%',
                    top: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    }
                },
                yAxis: [
                    {
                        type: 'category',
                        inverse: true,
                        show: true,
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        data: salvProName,
                        axisLabel: {
                            margin: 270,
                            show: true,
                            align: 'left',
                            color: '#5AACEA',
                            rich: {
                                a: {
                                    width: 66,
                                    fontSize: 14,
                                    align: 'left'
                                },
                                b: {
                                    width: 98,
                                    fontSize: 14,
                                    align: 'center'
                                },
                                c: {
                                    width: 98,
                                    fontSize: 14,
                                    align: 'center'
                                },
                                d: {
                                    width: 100,
                                    fontSize: 14,
                                    align: 'center'
                                }
                            },
                            formatter: function (params) {
                                if (index == salvProValue.length) {
                                    index = 0
                                }
                                index++
                                return ['{a|' + index + '.' + params + '}{b|' + salvProValue[index - 1] + '}{c|' + salvProValue2[index - 1] + '}'].join('\n')
                                // return `{a|${index + '.' + params}}{b|${salvProValue[index - 1]}}{c|${salvProValue2[index - 1]}}`
                            }
                        }
                    },
                    {
                        type: 'category',
                        inverse: true,
                        axisTick: 'none',
                        axisLine: 'none',
                        show: true,
                        axisLabel: {
                            textStyle: {
                                color: '#4DB0F4',
                                fontSize: '14'
                            }
                        },
                        data: salvProValue1.map(item => {
                            return item + '%'
                        })
                    }
                ],
                series: [
                    {
                        name: '背景',
                        type: 'bar',
                        barWidth: 14,
                        barGap: '-100%',
                        data: salvProMax,
                        itemStyle: {
                            normal: {
                                color: '#404D84',
                                barBorderRadius: 30
                            }
                        }
                    },
                    {
                        name: '值',
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                barBorderRadius: 30,
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                    {
                                        offset: 0,
                                        color: '#5472F2'
                                    },
                                    {
                                        offset: 1,
                                        color: '#5CBBE8'
                                    }
                                ])
                            }
                        },
                        barWidth: 14,
                        barMaxWidth: 14,
                        data: salvProValue1
                    },
                ]
            }
            var myChart = echarts.init(document.getElementById('access_ratio_echart'))
            myChart.setOption(option)
            myChart.resize({ height: 40 * salvProName.length })
        },
        // OTA
        OTAData(city, orderNum, totalNum, percentage) {
            // var salvProName = [
            //     '美团',
            //     '浙里好玩',
            //     '去哪儿网',
            //     '携程网',
            //     '同程网',
            //     '驴妈妈',
            //     '马蜂窝',
            // ]
            var salvProName = city
            var salvProValue = orderNum
            var salvProValue2 = totalNum
            var salvProValue1 = percentage
            let index = 0
            // if (this.dataIndex == 0) {
            //     var salvProValue = [890, 880, 720, 360, 0, 0, 0]
            //     var salvProValue1 = [90, 88, 72, 36, 0, 0, 0]
            //     var salvProValue2 = [850, 800, 620, 260, 0, 0, 0]
            // } else
            //     if (this.dataIndex == 0) {

            //         var salvProValue = [860, 810, 700, 360, 0, 0, 0]
            //         var salvProValue1 = [86, 81, 70, 36, 0, 0, 0]
            //         var salvProValue2 = [810, 710, 600, 260, 0, 0, 0]
            //     } else {

            //         var salvProValue = [790, 720, 680, 360, 0, 0, 0]
            //         var salvProValue1 = [79, 72, 68, 36, 0, 0, 0]
            //         var salvProValue2 = [700, 620, 600, 260, 0, 0, 0]
            //     }
            var salvProMax = [] //背景按最大值
            for (let i = 0; i < salvProValue.length; i++) {
                salvProMax.push(100)
            }
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none'
                    },
                    formatter: function (params) {
                        return params[1].name + ' : ' + params[1].value + '%'
                    }
                },
                legend: {
                    show: false
                },
                grid: {
                    height: 30 * salvProName.length,
                    left: -115,
                    right: '5%',
                    bottom: '2%',
                    top: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    }
                },
                yAxis: [
                    {
                        type: 'category',
                        inverse: true,
                        show: true,
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        data: salvProName,
                        axisLabel: {
                            margin: 280,
                            show: true,
                            align: 'left',
                            color: '#5AACEA',
                            rich: {
                                a: {
                                    width: 75,
                                    fontSize: 14,
                                    align: 'left'
                                },
                                b: {
                                    width: 100,
                                    fontSize: 14,
                                    align: 'center'
                                },
                                c: {
                                    width: 108,
                                    fontSize: 14,
                                    align: 'center'
                                },
                            },
                            formatter: function (params) {
                                if (index == salvProValue.length) {
                                    index = 0
                                }
                                index++
                                // return ['{a|' + index + '.' + params + '}{b|' + salvProValue2[index - 1] + '}'].join('\n')
                                return [
                                    '{a|' +
                                    index +
                                    '.' +
                                    params +
                                    '}{b|' +
                                    salvProValue[index - 1] +
                                    '}{c|' +
                                    salvProValue2[index - 1] +
                                    '}'
                                ].join('\n')
                            }
                        }
                    },
                    {
                        type: 'category',
                        inverse: true,
                        axisTick: 'none',
                        axisLine: 'none',
                        show: true,
                        axisLabel: {
                            textStyle: {
                                color: '#4DB0F4',
                                fontSize: '14',
                            }
                        },
                        data: salvProValue1.map(item => {
                            return item + '%'
                        })
                    }
                ],
                series: [
                    {
                        name: '背景',
                        type: 'bar',
                        barWidth: 14,
                        barGap: '-100%',
                        data: salvProMax,
                        itemStyle: {
                            normal: {
                                color: '#404D84',
                                barBorderRadius: 30
                            }
                        }
                    },
                    {
                        name: '值',
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                barBorderRadius: 30,
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                    {
                                        offset: 0,
                                        color: '#5472F2'
                                    },
                                    {
                                        offset: 1,
                                        color: '#5CBBE8'
                                    }
                                ])
                            }
                        },
                        barWidth: 14,
                        barMaxWidth: 14,
                        data: salvProValue1
                    },
                ]
            }
            var myChart = echarts.init(document.getElementById('OTA_data_echart')).setOption(option)
            myChart.resize({ height: 50 * salvProName.length })
        },
        scenicDetail(name) {
            console.log(name);
            if (name == '良渚古城遗址' || name == '良渚古城遗址公园') {
                this.isDialog = true
            }

        },
        closeDetail() {
            this.isDialog = false
        },
        onClickTap(index) {
            this.selectIndex = index
        },
        timeTap(index) {
            if (index == 0) {
                this.supData(this.appointment, [this.getDate(new Date()), this.getDate(new Date())])
            } else if (index == 1) {
                var date = new Date().getTime() + 3 * 24 * 3600 * 1000
                this.supData(this.appointment, [this.getDate(new Date()), this.getDate(new Date(date))])
            } else {
                var date = new Date().getTime() + 7 * 24 * 3600 * 1000
                this.supData(this.appointment, [this.getDate(new Date()), this.getDate(new Date(date))])
            }
            this.sputimeIndex = index
        },
        timeTap1(index) {
            this.sputimeIndex2 = index
        },
        //加载产品数量及分类图
        getProductMap() {
            let seriesData = [
                { value: 335, name: '直接访问' },
                { value: 310, name: '邮件营销' },
                { value: 234, name: '联盟广告' },
                { value: 135, name: '视频广告' }
            ]
            let legendData = ['直接访问', '邮件营销', '联盟广告', '视频广告']
            let option = pieOption.productMap(legendData, seriesData)
            this.productMap = echarts.init(document.getElementById('product-map'))
            this.productMap.setOption(option)
        },
        //spu处tap切换
        onClickSpuTap(index) {

            this.spuSelectIndex = index
        },
        //游客比例
        getRankMap(list) {
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c}%'
                },
                series: [
                    {
                        name: '游客年龄',
                        type: 'pie',
                        left: '8',
                        top: '10',
                        radius: ['50%', '90%'],
                        width: '130',
                        height: '140',
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '16',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: list
                    }
                ]
            }
            this.saleTotalMap = echarts.init(
                document.getElementById('sale-total-map')
            )
            this.saleTotalMap.setOption(option)
        },
        //客源地排名
        rankingOrigin(city, percentage) {
            // if (this.dataIndex == 0) {
            //     var salvProName = [
            //         '浙江省',
            //         '江西省',
            //         '海南省',
            //         '江苏省',
            //         '湖北省',
            //         '河南省',
            //         '河北省',
            //         '贵州省'
            //     ]
            //     var salvProValue = [86, 83, 77, 36, 30, 27, 20, 20]
            // } else
            // if (this.dataIndex == 0) {
            //     var salvProName = [
            //         '杭州市',
            //         '湖州市',
            //         '嘉兴市',
            //         '绍兴市',
            //         '宁波市',
            //         '舟山市',
            //         '温州市',
            //         '台州市'
            //     ]
            //     var salvProValue = [78, 69, 62, 36, 30, 27, 20, 20]
            // } else {
            //     var salvProName = [
            //         '西湖区',
            //         '上城区',
            //         '下城区',
            //         '江干区',
            //         '拱墅区',
            //         '滨江区',
            //         '余杭区',
            //         '萧山区'
            //     ]
            //     var salvProValue = [72, 64, 59, 36, 30, 27, 20, 20]
            // }
            var salvProName = city
            var salvProValue = percentage
            var salvProMax = [] //背景按最大值
            for (let i = 0; i < salvProValue.length; i++) {
                salvProMax.push(100)
            }
            let option = {
                grid: {
                    left: '0',
                    right: '20%',
                    bottom: '2%',
                    top: '0',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none'
                    },
                    formatter: function (params) {
                        return params[0].name + ' : ' + params[0].value + '%'
                    }
                },
                barMaxWidth: 14,
                barCategoryGap: 10,
                xAxis: {
                    show: false,
                    type: 'value'
                },
                yAxis: [
                    {
                        type: 'category',
                        inverse: true,
                        show: true,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#5AACEA'
                            }
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        data: salvProName
                    }
                ],
                series: [
                    {
                        name: '值',
                        type: 'bar',
                        zlevel: 1,
                        itemStyle: {
                            normal: {
                                barBorderRadius: 30,
                                color: '#90E8C4'
                            }
                        },
                        label: {
                            show: true,
                            position: 'right',
                            offset: [5, 0],
                            color: '#4DB0F4',
                            fontSize: '12',
                            formatter: '{c}%'
                        },
                        barWidth: 14,
                        barMaxWidth: 14,
                        data: salvProValue
                    }
                ]
            }
            echarts
                .init(document.getElementById('ranking_origin_echart'))
                .setOption(option)
        },
        // 游客行为分析
        touristBehavior(salvProName, salvProValue) {
            // var salvProName = [
            //     '0-2999',
            //     '3000-5999',
            //     '6000-8999',
            //     '9000-11999',
            //     '12000-14999',
            //     '15000-17999',
            // ]
            // if (this.dataIndex == 0) {
            //     var salvProValue = [86, 83, 77, 36, 30, 27, 20, 20]
            // } else if (this.dataIndex == 1) {
            //     var salvProValue = [78, 69, 62, 36, 30, 27, 20, 20]
            // } else {
            //     var salvProValue = [72, 64, 59, 36, 30, 27, 20, 20]
            // }

            var salvProMax = [] //背景按最大值
            for (let i = 0; i < salvProValue.length; i++) {
                salvProMax.push(100)
            }
            let option = {
                grid: {
                    left: '4%',
                    right: '15%',
                    bottom: '2%',
                    top: '0',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none'
                    },
                    formatter: function (params) {
                        return params[0].name + ' : ' + params[0].value + '%'
                    }
                },
                barMaxWidth: 14,
                barCategoryGap: 10,
                xAxis: {
                    show: false,
                    type: 'value'
                },
                yAxis: [
                    {
                        type: 'category',
                        inverse: true,
                        show: true,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#5AACEA'
                            }
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        data: salvProName
                    }
                ],
                series: [
                    {
                        name: '值',
                        type: 'bar',
                        zlevel: 1,
                        itemStyle: {
                            normal: {
                                barBorderRadius: 30,
                                color: '#90E8C4'
                            }
                        },
                        label: {
                            show: true,
                            position: 'right',
                            offset: [5, 0],
                            color: '#4DB0F4',
                            fontSize: '12',
                            formatter: '{c}%'
                        },
                        barWidth: 14,
                        barMaxWidth: 14,
                        data: salvProValue
                    }
                ]
            }
            echarts
                .init(document.getElementById('tourist_behavior_echart'))
                .setOption(option)
        },
        //预约出行比例
        TravelMap() {
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c}%'
                },
                series: [
                    {
                        name: '预约出行率',
                        type: 'pie',
                        radius: [0, 110],
                        center: ['40%', '80%'],
                        roseType: 'area',
                        width: '200',
                        height: '195',
                        top: '-30',
                        left: '80',
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '14',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            lineStyle: {
                                color: 'rgba(255, 255, 255, 0.3)'
                            },
                            smooth: 0.2,
                            length: 10,
                            length2: 20
                        },
                        data: [
                            {
                                value: 12,
                                name: '预约已出行',
                                itemStyle: {
                                    color: '#6E65EF'
                                }
                            },
                            {
                                value: 10,
                                name: '预约爽约',
                                itemStyle: {
                                    color: '#FFB833'
                                }
                            },
                            {
                                value: 15,
                                name: '预约中',
                                itemStyle: {
                                    color: '#6EB2ED'
                                }
                            }
                        ]
                    }
                ]
            }
            this.TravelMaps = echarts.init(document.getElementById('travel_map'))
            this.TravelMaps.setOption(option)
        },
        onClickSaleTap(index) {
            this.saleIndex = index
        },
        onClickSale(index) {
            this.saleTapIndex = index
        },
        getMap() {
            let mapOption = {
                title: "", //标题
                tooltip: { //此处是根据后端数据进行hover 展示的提示框，可用官网上默认的
                    trigger: "item",
                    formatter: function (params) {
                        return params.name + " ( " + params.data.value[2] + " ) " + "</br>"
                            + "飞机" + " : " + params.data.aircraftNum + "</br>";
                    }
                },
                legend: { //标签
                    orient: 'vertical',
                    y: 'bottom',
                    x: 'right',
                    data: ['行踪轨迹'],
                    textStyle: {
                        color: '#fff'
                    }
                },
                visualMap: {//颜色轴，可以根据数据点的值大小，展示不同的颜色，或用来展示地图块的不同颜色
                    min: 0,
                    max: 200,
                    calculable: true,
                    inRange: {
                        color: ["#3dda8e", "#eac736", "#d94e5d"]
                    },
                    textStyle: {
                        color: "#fff"
                    }
                },
                geo: {//配置地图参数
                    map: "china",
                    label: {
                        emphasis: {
                            show: false
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: "#058bd2",
                            borderColor: "#111"
                        },
                        emphasis: {
                            areaColor: "#1e67b2"
                        }
                    }
                },
                series: [
                    {//根据数据展示点，并显示为波纹效果
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        zlevel: 2,
                        //波纹效果
                        rippleEffect: {
                            period: 2,
                            brushType: 'stroke',
                            scale: 3
                        },
                        label: {
                            normal: {
                                show: true,
                                color: '#fff',
                                position: 'right',
                                formatter: '{b}'
                            }
                        },
                        //圆点大小
                        symbolSize: 16,
                        // data: convertData(data),
                    }
                ]
            };
            let myChart = echarts.init(document.getElementById('chinaMap'))
            myChart.setOption(mapOption);
        },
        initMap() {
            var that = this
            let myEchart = echarts.init(document.getElementById('chinaMap'))
            var cityMap = {
                中国: china,
                上海: shanghai,
                河北: hebei,
                山西: shangxi,
                内蒙古: neimenggu,
                辽宁: liaoning,
                吉林: jilin,
                黑龙江: heilongjiang,
                江苏: jiangsu,
                浙江: zhejiang,
                安徽: anhui,
                福建: fujian,
                江西: jiangxi,
                山东: shangdong,
                河南: henan
            }
            echarts.registerMap('浙江', cityMap['浙江'])
            var defaultOpt = {
                mapName: '浙江', // 地图展示
                goDown: true, // 是否下钻
                bgColor: '#1F274C', // 画布背景色
                activeArea: [], // 区域高亮,同echarts配置项
                data: [],
                // 下钻回调(点击的地图名、实例对象option、实例对象)
                callback: function (name, option, instance) { }
            }
            let opt = defaultOpt
            var name = [opt.mapName]
            var idx = 0
            var pos = {
                leftPlus: 115,
                leftCur: 150,
                left: 50,
                top: 20
            }

            var line = [
                [0, 0],
                [8, 11],
                [0, 22]
            ]
            // style
            var style = {
                font: '18px "Microsoft YaHei", sans-serif',
                textColor: '#eee',
                lineColor: 'rgba(147, 235, 248, 0)'
                //          lineColor: 'rgba(147, 235, 248, .8)'
            }
            let handleEvents = {
                resetOption: function (i, o, n) {
                    var breadcrumb = this.createBreadcrumb(n)
                    var j = name.indexOf(n)
                    var l = o.graphic.length
                    if (j < 0) {
                        o.graphic.push(breadcrumb)
                        o.graphic[0].children[0].shape.x2 = 145
                        o.graphic[0].children[1].shape.x2 = 145
                        if (o.graphic.length > 2) {
                            var cityData = []
                            var cityJson
                            for (var x = 0; x < opt.data.length; x++) {
                                if (n === opt.data[x].city) {
                                    $([opt.data[x]]).each(function (index, data) {
                                        cityJson = {
                                            city: data.city,
                                            name: data.name,
                                            value: data.value,
                                            crew: data.crew,
                                            company: data.company,
                                            position: data.position,
                                            region: data.region
                                        }
                                        cityData.push(cityJson)
                                    })
                                }
                            }
                            if (cityData != null) {
                                o.series[0].data = handleEvents.initSeriesData(cityData)
                            } else {
                                o.series[0].data = []
                            }
                        }
                        name.push(n)
                        idx++
                    } else {
                        o.graphic.splice(j + 2, l)
                        if (o.graphic.length <= 2) {
                            o.graphic[0].children[0].shape.x2 = 60
                            o.graphic[0].children[1].shape.x2 = 60
                            o.series[0].data = handleEvents.initSeriesData(opt.data)
                        }
                        name.splice(j + 1, l)
                        idx = j
                        pos.leftCur -= pos.leftPlus * (l - j - 1)
                    }

                    o.geo.map = n
                    o.geo.zoom = 0.4
                    i.clear()
                    i.setOption(o)
                    this.zoomAnimation()
                    opt.callback(n, o, i)
                },
                createBreadcrumb: function (name) {
                    var cityToPinyin = {
                        中国: 'china',
                        上海: 'shanghai',
                        河北: 'hebei',
                        山西: 'shangxi',
                        内蒙古: 'neimenggu',
                        辽宁: 'liaoning',
                        吉林: 'jilin',
                        黑龙江: 'heilongjiang',
                        江苏: 'jiangsu',
                        浙江: 'zhejiang',
                        安徽: 'anhui',
                        福建: 'fujian',
                        江西: 'jiangxi',
                        山东: 'shangdong',
                        河南: 'henan',
                        湖北: 'hubei',
                        湖南: 'hunan',
                        广东: 'guangdong',
                        广西: 'guangxi',
                        海南: 'hainan',
                        四川: 'sichuan',
                        贵州: 'guizhou',
                        云南: 'yunnan',
                        西藏: 'xizang',
                        陕西: 'shanxi',
                        甘肃: 'gansu',
                        青海: 'qinghai',
                        宁夏: 'ningxia',
                        新疆: 'xinjiang',
                        北京: 'beijing',
                        天津: 'tianjin',
                        重庆: 'chongqing',
                        香港: 'xianggang',
                        澳门: 'aomen'
                    }

                    var breadcrumb = {
                        type: 'group',
                        id: name,
                        left: 100,
                        top: pos.top + 3,
                        children: [
                            {
                                type: 'polyline',
                                left: -100,
                                top: -5,
                                shape: {
                                    points: line
                                },
                                style: {
                                    stroke: '#fff',
                                    key: name
                                    // lineWidth: 2,
                                },
                                onclick: function () {
                                    var name = this.style.key
                                    handleEvents.resetOption(myEchart, option, name)
                                }
                            },
                            {
                                type: 'text',
                                left: -68,
                                top: 'middle',
                                style: {
                                    text: name,
                                    textAlign: 'center',
                                    fill: style.textColor,
                                    font: style.font
                                },
                                onclick: function () {
                                    var name = this.style.text
                                    handleEvents.resetOption(myEchart, option, name)
                                }
                            },
                            {
                                type: 'text',
                                left: -68,
                                top: 10,
                                style: {
                                    name: name,
                                    text: cityToPinyin[name]
                                        ? cityToPinyin[name].toUpperCase()
                                        : '',
                                    textAlign: 'center',
                                    fill: style.textColor,
                                    font: '12px "Microsoft YaHei", sans-serif'
                                },
                                onclick: function () {
                                    var name = this.style.name
                                    handleEvents.resetOption(myEchart, option, name)
                                }
                            }
                        ]
                    }

                    pos.leftCur += pos.leftPlus
                    if (name == '浙江') {
                        setTimeout(() => {
                            that.dataIndex = 1
                            this.appointment = 0
                            // that.setOrderMap()
                            that.touristConsumption()
                            // that.rankingOrigin()
                            // that.accessrEchart()
                        }, 100)
                    }
                    return breadcrumb
                },
                // 设置effectscatter
                initSeriesData: function (data) {
                    var temp = []
                    for (var i = 0; i < data.length; i++) {
                        var geoCoord = geoCoordMap[data[i].name]
                        if (geoCoord) {
                            temp.push({
                                name: data[i].name,
                                value: geoCoord.concat(data[i].value),
                                crew: data[i].crew,
                                company: data[i].company,
                                position: data[i].position,
                                region: data[i].region
                            })
                        }
                    }
                    return temp
                },
                zoomAnimation: function () {
                    var count = null
                    var zoom = function (per) {
                        if (!count) count = per
                        count = count + per
                        myEchart.setOption({
                            geo: {
                                zoom: count
                            }
                        })
                        if (count < 1)
                            window.requestAnimationFrame(function () {
                                zoom(0.4)
                            })
                    }
                    window.requestAnimationFrame(function () {
                        zoom(0.4)
                    })
                }
            }
            var option = {
                backgroundColor: opt.bgColor,
                tooltip: {
                    show: true,
                    trigger: 'item',
                    alwaysShowContent: false,
                    backgroundColor: 'rgba(50,50,50,0.7)',
                    hideDelay: 100,
                    triggerOn: 'click',
                    enterable: true,
                    position: ['60%', '70%']
                },
                graphic: [
                    {
                        type: 'group',
                        left: pos.left,
                        top: pos.top - 4,
                        children: [
                            {
                                type: 'line',
                                left: 0,
                                top: -20,
                                shape: {
                                    x1: 0,
                                    y1: 0,
                                    x2: 60,
                                    y2: 0
                                },
                                style: {
                                    stroke: style.lineColor
                                }
                            },
                            {
                                type: 'line',
                                left: 0,
                                top: 20,
                                shape: {
                                    x1: 0,
                                    y1: 0,
                                    x2: 60,
                                    y2: 0
                                },
                                style: {
                                    stroke: style.lineColor
                                }
                            }
                        ]
                    },
                    {
                        id: name[idx],
                        type: 'group',
                        left: pos.left + 2,
                        top: pos.top,
                        children: [
                            {
                                type: 'polyline',
                                left: 90,
                                top: -12,
                                shape: {
                                    points: line
                                },
                                style: {
                                    stroke: 'transparent',
                                    key: name[0]
                                },
                                onclick: function () {
                                    var name = this.style.key
                                    // handleEvents.resetOption(myEchart, option, name)
                                }
                            },
                            {
                                type: 'text',
                                left: 0,
                                top: 'middle',
                                style: {
                                    text: '浙江',
                                    textAlign: 'center',
                                    fill: style.textColor,
                                    font: style.font
                                },
                                onclick: function () {
                                    // handleEvents.resetOption(myEchart, option, '浙江')
                                }
                            },
                            {
                                type: 'text',
                                left: 0,
                                top: 10,
                                style: {
                                    text: 'zhejiang',
                                    textAlign: 'center',
                                    fill: style.textColor,
                                    font: '12px "Microsoft YaHei", sans-serif'
                                },
                                onclick: function () {
                                    // handleEvents.resetOption(myEchart, option, 'zhejiang')
                                }
                            }
                        ]
                    }
                ],
                geo: {
                    map: opt.mapName,
                    zoom: 1.2,
                    regions: [
                        {
                            name: '南海诸岛',
                            itemStyle: {
                                // 隐藏地图
                                normal: {
                                    opacity: 0 // 为 0 时不绘制该图形
                                }
                            },
                            label: {
                                show: false // 隐藏文字
                            }
                        }
                    ],
                    label: {
                        normal: {
                            show: true,
                            textStyle: {
                                color: '#fff'
                            }
                        },
                        emphasis: {
                            show: true,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            borderColor: 'rgba(147, 235, 248, 1)',
                            borderWidth: 1,
                            areaColor: {
                                type: 'radial',
                                x: 0.5,
                                y: 0.5,
                                r: 0.8,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: 'rgba(147, 235, 248, 0)' // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(147, 235, 248, .2)' // 100% 处的颜色
                                    }
                                ],
                                globalCoord: false // 缺省为 false
                            },
                            shadowColor: 'rgba(128, 217, 248, 1)',
                            // shadowColor: 'rgba(255, 255, 255, 1)',
                            shadowOffsetX: -2,
                            shadowOffsetY: 2,
                            shadowBlur: 10
                        },
                        emphasis: {
                            areaColor: '#389BB7',
                            borderWidth: 0
                        }
                    }
                },
                series: [
                    {
                        type: 'map',
                        coordinateSystem: 'geo',
                        showEffectOn: 'render',
                        rippleEffect: {
                            period: 15,
                            scale: 4,
                            brushType: 'fill'
                        },
                        hoverAnimation: true,
                        itemStyle: {
                            normal: {
                                color: '#FFC848',
                                shadowBlur: 10,
                                shadowColor: '#333'
                            }
                        },
                        data: handleEvents.initSeriesData(opt.data)
                    }
                ]
            }
            myEchart.setOption(option)
            // 添加事件
            myEchart.on('click', function (params) {
                clearTimeout(this.timer)
                if (!params.name) {
                    that.supName = params.name
                    that.dataIndex = 0
                    that.appointment = 0
                    // that.setOrderMap()
                    that.touristConsumption()
                    that.totalappointments()
                    // that.rankingOrigin()
                    // that.accessrEchart()
                } else {
                    that.dataIndex = 2
                    that.appointment = 1
                    that.sputimeIndex = 0
                    that.supName = params.name
                    that.supData(that.appointment, [that.getDate(new Date()), that.getDate(new Date())])
                    that.totalappointments()
                    // that.setOrderMap()
                    that.touristConsumption()
                    // that.rankingOrigin()
                    // that.accessrEchart()
                }
                // if (params.name == '杭州市') {
                //     that.dataIndex = 2
                //     that.appointment = 1
                //     // that.setOrderMap()
                //     that.touristConsumption()
                //     // that.rankingOrigin()
                //     that.accessrEchart()
                // } else {
                //     that.dataIndex = 0
                //     that.appointment = 0
                //     // that.setOrderMap()
                //     that.touristConsumption()
                //     // that.rankingOrigin()
                //     that.accessrEchart()
                // }
                var _self = this
                if (opt.goDown && params.name != name[idx]) {
                    if (cityMap[params.name]) {
                        echarts.registerMap(params.name, cityMap[params.name])
                        handleEvents.resetOption(_self, option, params.name)
                    } else {
                        selectArea(params)
                    }
                }
            })
            // 点击的位置没有地图数据时
            function selectArea(params) {
                let name = params.name
                myEchart.setOption({
                    geo: {
                        type: 'map',
                        regions: [
                            {
                                name: name,
                                selected: true
                            }
                        ]
                    }
                })
            }
            myEchart.on('mapselectchanged', function (data) {
            })
        },
        // 游客消费3d饼图
        initChart(percentage) {
            let options = {
                chart: {
                    type: 'pie',
                    options3d: {
                        enabled: true,
                        alpha: 45,
                        beta: 0
                    },
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    backgroundColor: 'rgba(255, 255, 255, 0)',
                    style: {
                        fontFamily: '',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: '#006cee'
                    }
                },
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        depth: 35,
                        dataLabels: {
                            enabled: true,
                            format:
                                '<span style="color:{point.color};font-weight:400;">{point.y}元</span>'
                        }
                    }
                },
                series: [
                    {
                        type: 'pie',
                        name: '消费占比',
                        size: '92%',
                        dataLabels: {
                            distance: 5,
                            style: {
                                textOutline: 'none'
                            }
                        },
                        data: percentage
                        // [
                        //     { name: '景区', y: 10000, color: '#4E7DF4' },
                        //     { name: '住宿', y: 10000, color: '#EDA669' },
                        //     { name: '餐饮', y: 9000, color: '#87B5E7' },
                        //     { name: '购物', y: 6000, color: '#8088E2' },
                        //     { name: '娱乐', y: 8000, color: '#A5E98A' },
                        //     { name: '交通', y: 3000, color: '#F75E6C' }
                        // ]
                    }
                ]
            }
            this.chart = new Highcharts.Chart('tourist-consumption-img', options)
        },
        // 游客消费排名
        touristConsumption() {
            // if (this.dataIndex == 0) {
            //     var salvProName = ['浙江', '江西', '海南', '江苏', '湖北', '河南']
            //     var salvProValue = [90, 80, 70, 66, 60, 58, 44]
            // } else
            if (this.dataIndex == 0) {
                var salvProName = [
                    '杭州',
                    '湖州',
                    '嘉兴',
                    '绍兴',
                    '宁波',
                    '舟山',
                    '温州'
                ]
                var salvProValue = [90, 88, 75, 72, 56, 40, 20]
            } else {
                var salvProName = ['西湖', '上城', '下城', '江干', '拱墅', '滨江']
                var salvProValue = [83, 80, 76, 73, 58, 44, 40]
            }
            // var salvProName = [
            //     '杭州',
            //     '湖州',
            //     '嘉兴',
            //     '绍兴',
            //     '宁波',
            //     '舟山',
            //     '温州'
            // ]
            // var salvProValue = [1, 1, 1, 1, 1, 1, 1]
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params) {
                        return params[1].name + ' : ' + params[1].value + '%'
                    }
                },
                grid: {
                    top: '10%',
                    right: '3%',
                    left: '15%',
                    bottom: '12%'
                },
                xAxis: [
                    {
                        type: 'category',
                        data: salvProName,
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.12)'
                            }
                        },
                        axisLabel: {
                            margin: 10,
                            color: '#4DB0F4',
                            textStyle: {
                                fontSize: 12
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: '(%)',
                        nameLocation: 'end',
                        nameTextStyle: {
                            color: '#4DB0F4',
                            align: 'right'
                        },
                        max: 100,
                        splitNumber: 5,
                        interval: 20,
                        axisLabel: {
                            color: '#4DB0F4'
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#233e64'
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '背景',
                        type: 'bar',
                        barWidth: 12,
                        barGap: '-100%',
                        data: [100, 100, 100, 100, 100, 100, 100],
                        itemStyle: {
                            normal: {
                                color: '#404D84',
                                barBorderRadius: [30, 30, 0, 0]
                            }
                        }
                    },
                    {
                        type: 'bar',
                        data: salvProValue,
                        barWidth: 12,
                        itemStyle: {
                            normal: {
                                color: '#4DB0F4',
                                barBorderRadius: [30, 30, 0, 0]
                            }
                        }
                    }
                ]
            }
            echarts.init(document.getElementById('tourist-consumption-echart')).setOption(option)
        }
    },
    components: {
        scenicDetails,
    }
}
</script>
<style scoped>
.new-spu-list > div {
    display: flex;
    color: #fff;
    font-size: 15px;
    line-height: 2.4;
}

.new-spu-list > div .name-new {
    width: 110px;
    text-align: left;
    display: flex;
    align-items: center;
}
.new-spu-list > div .name-new span:nth-child(1) {
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background-color: var(--backColor);
}
.new-spu-list > div .name-new span:nth-child(2) {
    margin-left: 6px;
    width: 80px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
}
.new-spu-list > div .number-new {
    text-align: center;
    overflow: hidden;
    color: '#4DB0F4';
}
@keyframes myanimate1 {
    from {
        top: 0px;
    }

    to {
        top: var(--heightSpu);
    }
}

@keyframes myanimate2 {
    from {
        top: 0px;
    }

    to {
        top: var(--heightSpu);
    }
}

@keyframes myanimate5 {
    from {
        top: var(--heightSpuO);
    }

    to {
        top: var(--heightSpu);
    }
}

.animation_m1 {
    padding-top: 147px;
    position: relative;
    animation: myanimate1 20s linear 2s infinite;
}

.animation_m2 {
    padding-top: 147px;
    position: relative;
    animation: myanimate2 20s linear 2s infinite;
}

.restart {
    padding-top: 147px;
    position: relative;
    animation: myanimate5 15s linear 2s infinite;
}

@keyframes myanimate3 {
    from {
        top: 0px;
    }

    to {
        top: var(--heightOTA);
    }
}

#OTA_data_echart {
    width: 100%;
    animation: myanimate3 15s linear 2s infinite;
}

.OTA_data_echartsss {
    min-height: 250px;
}

.noData {
    position: absolute;
    width: 120px;
    top: 0;
    right: -370px;
    font-size: 15px;
}

.access_ratio_echartss {
    min-height: 350px;
}

.access_ratio_scroll {
    overflow-x: hidden;
    overflow-y: scroll;
    height: 200px;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
}

.access_ratio_scroll::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
}

.order_lamp {
    font-size: 12px;
    color: #fff;
    padding: 0px 64px;
    background-color: #0d1430;
    margin: 60px 0 10px;
    text-align: center;
    width: 670px;
    box-sizing: border-box;
    height: 30px;
    line-height: 30px;
}

.swiper-container {
    height: 100%;
    font-size: 12px;
}
.swiper-slide {
    height: 30px;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/echart/systemDataDisplay.vue